import React from "react";
import * as PhosphorIcon from "@phosphor-icons/react";

export function Icon({ icon, ...rest }) {
  return React.createElement(PhosphorIcon[icon], rest);
}
